import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/row';
import Col from 'react-bootstrap/Col';
import '../../App.css'
import './Header.css'

import { DesktopHeader } from './DesktopViewHeader/DesktopHeader';
import { MobileHeader } from './MobileViewHeader/MobileHeader';
export const Header = () => {
    return (
        <header class="common-header">
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <DesktopHeader />
                        {/* <MobileHeader /> */}
                    </Col>
                </Row>
            </Container>
        </header>
    )
}
